/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import { MetricNamespacesImpl } from "./operations/index.js";
import { MetricNamespaces } from "./operationsInterfaces/index.js";
import { MonitorManagementClientContext } from "./monitorManagementClientContext.js";
import {
  MonitorManagementClientOptionalParams,
  ApiVersion20240201
} from "./models/index.js";

/** @internal */
export class MonitorManagementClient extends MonitorManagementClientContext {
  /**
   * Initializes a new instance of the MonitorManagementClient class.
   * @param apiVersion Api Version
   * @param options The parameter options
   */
  constructor(
    apiVersion: ApiVersion20240201,
    options?: MonitorManagementClientOptionalParams
  ) {
    super(apiVersion, options);
    this.metricNamespaces = new MetricNamespacesImpl(this);
  }

  metricNamespaces: MetricNamespaces;
}
